const firstWords = [
  "amber",
  "apple",
  "brave",
  "bright",
  "cinder",
  "clear",
  "copper",
  "daring",
  "ember",
  "gentle",
  "golden",
  "grand",
  "hidden",
  "honest",
  "ivory",
  "juniper",
  "kind",
  "lucky",
  "maple",
  "mellow",
  "mossy",
  "noble",
  "paper",
  "pebble",
  "quiet",
  "river",
  "silver",
  "soft",
  "story",
  "sunny",
  "velvet",
  "wild",
] as const;

const secondWords = [
  "acorn",
  "balloon",
  "berry",
  "brook",
  "canyon",
  "castle",
  "cloud",
  "comet",
  "garden",
  "harbor",
  "lantern",
  "meadow",
  "moon",
  "morning",
  "mountain",
  "ocean",
  "orchard",
  "paper",
  "path",
  "piano",
  "planet",
  "prairie",
  "rainbow",
  "rocket",
  "shadow",
  "song",
  "spark",
  "stream",
  "summer",
  "thunder",
  "willow",
  "window",
] as const;

const thirdWords = [
  "adventure",
  "answer",
  "chapter",
  "clue",
  "compass",
  "curiosity",
  "drift",
  "echo",
  "forest",
  "friend",
  "glimmer",
  "harvest",
  "journey",
  "legend",
  "lesson",
  "memory",
  "mystery",
  "parade",
  "puzzle",
  "riddle",
  "signal",
  "skyline",
  "starlight",
  "story",
  "sunrise",
  "telescope",
  "ticket",
  "treasure",
  "valley",
  "voyage",
  "whisper",
  "wonder",
] as const;

const fourthWords = [
  "atlas",
  "beacon",
  "bridge",
  "campfire",
  "caravan",
  "circle",
  "doorway",
  "feather",
  "glow",
  "harvest",
  "horizon",
  "lantern",
  "library",
  "meadow",
  "mirror",
  "nest",
  "parade",
  "path",
  "porch",
  "quartz",
  "river",
  "signal",
  "studio",
  "sunbeam",
  "tunnel",
  "violet",
  "wagon",
  "window",
  "workshop",
  "world",
  "yard",
  "zeppelin",
] as const;

function pickWord<T extends readonly string[]>(words: T, value: number) {
  return words[value % words.length];
}

export function generateShowSlug(randomValues?: Uint32Array): string {
  const values = randomValues ?? crypto.getRandomValues(new Uint32Array(4));

  return [
    pickWord(firstWords, values[0] ?? 0),
    pickWord(secondWords, values[1] ?? 0),
    pickWord(thirdWords, values[2] ?? 0),
    pickWord(fourthWords, values[3] ?? 0),
  ].join("-");
}

export function buildCastPath(slug: string): string {
  return `/casts/${slug}`;
}
